import app from '../angular_app.es6';
import { debounce } from 'lodash';

app.factory('TranslationService', [() => {

  const dataHash = {
    defaultLanguage: true
  };

  return {
    setisDefaultLanguage: (defaultLanguage) => { dataHash.defaultLanguage = defaultLanguage },
    isDefaultLanguage: () => { return dataHash.defaultLanguage; }
  }
}]);